/**
 * Created by ldang on 9/12/2017.
 */
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'confirm-delete',
  template: '<h2 matDialogTitle>Confirmation</h2>' +
  '<mat-dialog-content>' +
  '{{data}}' +
  '</mat-dialog-content>' +
  '<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">' +
  '<button mat-button matDialogClose>No</button>' +
  '<button mat-raised-button [matDialogClose]="true" color="primary">Yes</button>' +
  '</mat-dialog-actions>'
})
export class ConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) {
  }
}
